<ng-container *ngIf="appData">
  <router-outlet></router-outlet>
</ng-container>


<ngx-spinner  size="small" type="pacman">
  <p style="color: white">Loading </p>
</ngx-spinner>

<!-- Shown automatically while any API call is in flight (SpinInterceptor) -->
<ngx-spinner name="api" size="small" type="pacman" [fullScreen]="true">
  <p style="color: white">Loading </p>
</ngx-spinner>
